/* @refresh reload */
import { render } from "solid-js/web";
import { App } from "./App";
import "./assets/styles.css";

const root = document.getElementById("root");
if (!root) throw new Error("#root not found");

render(() => <App />, root);

if (import.meta.env.DEV) {
  // Phase 3 smoke handle: open devtools and run e.g. await __searchHybrid("blockchain", 5)
  void import("./search/hybrid").then(({ searchHybrid }) => {
    Object.assign(window, { __searchHybrid: searchHybrid });
    console.info(
      "[search] dev handle ready: window.__searchHybrid(query, topK).",
      "First call downloads the model (~33 MB) and the DB (~4 MB).",
    );
  });
}
